import { render, staticRenderFns } from "./ModalProgrammedRestricions.vue?vue&type=template&id=754660c2&"
import script from "./ModalProgrammedRestricions.vue?vue&type=script&lang=js&"
export * from "./ModalProgrammedRestricions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports